import Action from 'redux/helpers/createAction'
const name = 'billing'

export const changePlan = Action(name + '/BILLING_CHANGE_PLAN_REQUEST', payload => ({
  payload
}))
export const changePlanSuccess = Action(name + '/BILLING_CHANGE_PLAN_SUCCESS', message => ({
  message
}))
export const changePlanFailure = Action(name + '/BILLING_CHANGE_PLAN_FAILURE', errors => ({
  errors
}))

export const purchaseAddOn = Action(name + '/BILLING_PURCHASE_ADDON_REQUEST', payload => ({
  payload
}))
export const purchaseAddOnSuccess = Action(name + '/BILLING_PURCHASE_ADDON_SUCCESS', data => ({
  data
}))
export const purchaseAddOnFailure = Action(name + '/BILLING_PURCHASE_ADDON_FAILURE', errors => ({
  errors
}))

export const loadInvoices = Action(name + '/BILLING_LOAD_INVOICES_REQUEST')
export const loadInvoicesSuccess = Action(name + '/BILLING_LOAD_INVOICES_SUCCESS', invoices => ({
  invoices
}))
export const loadInvoicesFailure = Action(name + '/BILLING_LOAD_INVOICES_FAILURE', errors => ({
  errors
}))
